import React, { useState } from 'react';
import './DrinkFlavorPage.css';

export default function DrinkFlavorPage({ item, cart, onAddToCart, onUpdateQuantity, onBack }) {
  const flavors = item.combo_options ? item.combo_options.split('|') : [];
  const hasTempChoice = item.temperature === 'both';

  const [selectedFlavor, setSelectedFlavor] = useState(null);
  const [selectedTemp, setSelectedTemp] = useState('冰');

  const existingItems = cart.filter(c => c.id === item.id);

  const handleAdd = () => {
    if (!selectedFlavor) return;
    const temp = hasTempChoice ? selectedTemp
      : item.temperature === 'ice' ? '冰'
      : item.temperature === 'hot' ? '熱' : null;
    const cartKey = temp ? `${item.id}_${selectedFlavor}_${temp}` : `${item.id}_${selectedFlavor}`;
    const displayName = temp ? `${item.name}(${selectedFlavor})(${temp})` : `${item.name}(${selectedFlavor})`;
    onAddToCart({ id: item.id, cartKey, displayName, price: item.price, size: null });
  };

  return (
    <div className="flavor-page">
      <div className="flavor-header">
        <button className="flavor-back" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          返回
        </button>
        <span className="flavor-title">{item.name}</span>
        <span className="flavor-price">${item.price}</span>
      </div>

      <div className="flavor-body">
        {existingItems.length > 0 && (
          <div className="flavor-section">
            <div className="flavor-section-label">已加入購物車</div>
            <div className="flavor-existing-list">
              {existingItems.map(ci => (
                <div key={ci.cartKey} className="flavor-existing-row">
                  <span className="flavor-existing-name">{ci.displayName}</span>
                  <div className="qty-ctrl">
                    <button onClick={() => onUpdateQuantity(ci.cartKey, -1)}>−</button>
                    <span>{ci.quantity}</span>
                    <button onClick={() => onUpdateQuantity(ci.cartKey, 1)}>+</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="flavor-section">
          <div className="flavor-section-label">選擇口味</div>
          <div className="flavor-options">
            {flavors.map(flavor => (
              <button
                key={flavor}
                className={`flavor-btn${selectedFlavor === flavor ? ' selected' : ''}`}
                onClick={() => setSelectedFlavor(flavor)}
              >
                {flavor}
              </button>
            ))}
          </div>
        </div>

        {hasTempChoice && (
          <div className="flavor-section">
            <div className="flavor-section-label">選擇溫度</div>
            <div className="flavor-temp-row">
              <button
                className={`flavor-temp-btn temp-ice${selectedTemp === '冰' ? ' selected' : ''}`}
                onClick={() => setSelectedTemp('冰')}
              >冰</button>
              <button
                className={`flavor-temp-btn temp-hot${selectedTemp === '熱' ? ' selected' : ''}`}
                onClick={() => setSelectedTemp('熱')}
              >熱</button>
            </div>
          </div>
        )}
      </div>

      <div className="flavor-footer">
        <button
          className={`flavor-add-btn${!selectedFlavor ? ' disabled' : ''}`}
          onClick={handleAdd}
          disabled={!selectedFlavor}
        >
          {selectedFlavor
            ? `加入購物車（${selectedFlavor}${hasTempChoice ? `・${selectedTemp}` : ''}）`
            : '請先選擇口味'}
        </button>
      </div>
    </div>
  );
}
